/* eslint-disable */
// WARNING: This file is generated during build from Gen 2 outputs and amplify/runtime-config.json.

const awsmobile = {
  "aws_project_region": "ap-south-1",
  "aws_cognito_identity_pool_id": "ap-south-1:77043f81-cfb8-4a8b-80c7-84d18cd9ce81",
  "aws_cognito_region": "ap-south-1",
  "aws_user_pools_id": "ap-south-1_IVF3tg11c",
  "aws_user_pools_web_client_id": "3e9fnm3hfms8v3aamid0dpp73f",
  "oauth": {},
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "GIVEN_NAME",
    "FAMILY_NAME",
    "EMAIL",
    "PHONE_NUMBER"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "meadocumentsbucket130849-testnext",
  "aws_user_files_s3_bucket_region": "ap-south-1"
};

export default awsmobile;
